module.exports = __webpack_public_path__ + "static/photo-ea5e0df7676aec7f4fa772f2b78f55d8.png";